import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { Observable, map, takeUntil } from 'rxjs';
import {
  CustomResultOfListOfGetFormBuilderFieldsListDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import {
  EnumsService,
  FormBuilderFieldsService,
} from 'src/app/core/api/services';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
  selector: 'form-builder-fields-select-search',
  templateUrl: './base/base-select-search-template.html',
  imports: [BaseSelectSearchModule],
})
export class FormBuilderFieldsSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  FormBuilderFieldTypesEnumValues: GetEnumValuesDto[] = [];

  @Output('fieldType') output_fieldType = new EventEmitter<any>();

  constructor(
    protected currentService: FormBuilderFieldsService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  ngOnInit() {
    this.getEnumValuesApi('FormBuilderFieldTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => {
        this.FormBuilderFieldTypesEnumValues = values;
        this.initConfig();
        this.getItems();
      });
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
  }

  getItemsApi() {
    this.currentService
      .formBuilderFieldsGetFormBuilderFieldsList()
      .pipe(
        this.basePipeOperators(),
        map((items: CustomResultOfListOfGetFormBuilderFieldsListDto) => {
          return items?.data?.map((item) => {
            let translatedFieldTypes = '';
            translatedFieldTypes = this.enumToTextConvertorPipe.transform(
              item?.fieldType,
              this.FormBuilderFieldTypesEnumValues
            );

            return {
              ...item,
              optionTitle: `  ${item?.isRequired ? ' * ' : ''} ${
                item?.title
              } (${translatedFieldTypes})  `,
            };
          });
        })
      )
      .subscribe(this.baseObserver);
  }

  emitFieldType(fieldType) {
    this.output_fieldType.emit(fieldType);
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }

  baseObserver = {
    next: (items) => {
      if (items?.data) this.items = items?.data;
      else this.items = items;
      let selectedItem = this.items.find((res) => res.id === this.value);
      if (selectedItem) this.emitFieldType(selectedItem?.fieldType);
      this.setDefaultValue();
    },
    error: (error) => {
      this.emitError();
    },
    complete: () => {
      this.initLoading = false;
      this.isFetchData = true;
    },
  };
}
